import React, { Suspense } from 'react'
import { Route } from 'react-router-dom'
const InvalidToken = React.lazy(() => import('./InvalidToken'))
const VerifyEmailError = React.lazy(() => import('./VerifyEmailError'))
const Authorize = React.lazy(() => import('./Authorize'))
const Login = React.lazy(() => import('./Login'))
const Logout = React.lazy(() => import('./Logout'))
const Layout = React.lazy(() => import('./Layout'))
const VerifyEmail = React.lazy(() => import('./VerifyEmail'))
const Forgot = React.lazy(() => import('./Forgot'))
const Reset = React.lazy(() => import('./Reset'))
const Enroll = React.lazy(() => import('./Enroll'))
const RouteWithProps = React.lazy(() => import('App/helpers/RouteWithProps'))
const Register = React.lazy(() => import('./Register'))

// prettier-ignore
export default (
  <Route element={<Suspense><RouteWithProps component={Layout} /></Suspense>}>
    {/* <Route element={<Suspense><RouteWithProps component={Layout2} /></Suspense>} /> */}
    <Route path="/login" element={<Suspense><Login /></Suspense>} />
    <Route path="/logout" element={<Suspense><Logout /></Suspense>} />
    <Route path="/verify-email" element={<Suspense><RouteWithProps component={VerifyEmailError} /></Suspense>} />
    <Route path="/verify-email/:token" element={<RouteWithProps component={VerifyEmail} />} />
    <Route path="/forgot" element={<Suspense><Forgot /></Suspense>} />
    <Route path="/register*" element={<Suspense><Register /></Suspense>} />
    <Route path="/reset/:token" element={<Suspense><RouteWithProps component={Reset} /></Suspense>} />
    <Route path="/enroll/:token" element={<Suspense><RouteWithProps component={Enroll} /></Suspense>} />
    <Route path="/authorize" element={<Suspense><Authorize /></Suspense>} />
    <Route path="/invalid-token" element={<Suspense><InvalidToken /></Suspense>} />
  </Route>
)
